interface BookHeroProps {
  title: string;
  type: "book-of-the-month" | "search";
}

const BookHero = ({ title, type }: BookHeroProps) => {
  return (
    <div className="book-hero-section container mx-auto">
      {/* <div className="p-[30px] text-neutral-600 max-w-[1440px] w-full mx-auto relative">
        <div className="flex flex-col gap-y-[10px]">
          <h1 className="text-[48px] font-bold">{title}</h1>
          <h4 className="text-[24px]">
            {type === "book-of-the-month" && "Book of the Month"}
            {type === "search" &&
              "Search for a book you read, and take the quiz to earn points"}
          </h4>
        </div>
        <div className="absolute right-0 top-0 h-full overflow-hidden opacity-50">
          <img
            src="/assets/reading-a-book.png"
            alt="reading-a-book"
            width={500}
            height={500}
            className="object-cover"
          />
        </div>
      </div> */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        viewBox="0 0 1266 367"
        fill="none"
      >
        <rect x="1" width="1265" height="367" rx="20" fill="var(--secondary)" />
        <g clip-path="url(#clip0_554_324)">
          <path
            d="M1 221.501C1 215.157 6.83124 210.416 13.0416 211.712L43.1667 217.994C85.3333 226.46 169.667 244.541 254 266.156C338.333 288.1 422.667 314.4 507 305.606C591.333 297.141 675.667 252.76 760 217.994C844.333 182.9 928.667 156.6 1013 152.244C1097.33 147.56 1181.67 165.641 1223.83 174.106L1258.04 181.24C1262.68 182.207 1266 186.294 1266 191.03V357C1266 362.523 1261.52 367 1256 367H1223.83C1181.67 367 1097.33 367 1013 367C928.667 367 844.333 367 760 367C675.667 367 591.333 367 507 367C422.667 367 338.333 367 254 367C169.667 367 85.3333 367 43.1667 367H11C5.47716 367 1 362.523 1 357V221.501Z"
            fill="white"
            fill-opacity="0.1"
          />
        </g>
        <g clip-path="url(#clip1_554_324)">
          <path
            d="M1265 218.501C1265 212.157 1259.17 207.416 1252.96 208.712L1222.83 214.994C1180.67 223.46 1096.33 241.541 1012 263.156C927.667 285.1 843.333 311.4 759 302.606C674.667 294.141 590.333 249.76 506 214.994C421.667 179.9 337.333 153.6 253 149.244C168.667 144.56 84.3334 162.641 42.1666 171.106L7.95837 178.24C3.32214 179.207 0 183.294 0 188.03V354C0 359.523 4.47717 364 10 364H42.1666C84.3334 364 168.667 364 253 364C337.333 364 421.667 364 506 364C590.333 364 674.667 364 759 364C843.333 364 927.667 364 1012 364C1096.33 364 1180.67 364 1222.83 364H1255C1260.52 364 1265 359.523 1265 354V218.501Z"
            fill="white"
            fill-opacity="0.1"
          />
        </g>
        <defs>
          <clipPath id="clip0_554_324">
            <rect
              width="1265"
              height="216"
              fill="white"
              transform="translate(1 151)"
            />
          </clipPath>
          <clipPath id="clip1_554_324">
            <rect
              width="1265"
              height="216"
              fill="white"
              transform="matrix(-1 0 0 1 1265 148)"
            />
          </clipPath>
        </defs>
      </svg>

      <div className="flex flex-col gap-y-[10px] book-hero-text">
        <h1 className="text-[24px] lg:text-[48px] font-[900]">{title}</h1>
        <h4 className="text-[16px] lg:text-[24px]">
          {type === "book-of-the-month" && "Book of the Month"}
          {type === "search" &&
            "Search for a book you read, and take the quiz to earn points"}
        </h4>
      </div>
    </div>
  );
};

export default BookHero;
